import React from 'react'
import { cn } from '~/lib'

type BadgeProps = {
  className?: string | undefined
  children?: React.ReactNode | undefined
}

export default function Badge({ className, children }: BadgeProps) {
  return (
    <span className={cn('inline-flex rounded-md px-2', className)}>
      {children}
    </span>
  )
}
